"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultRole = exports.Role = void 0;
var React = __importStar(require("react"));
require("./RolesPermissions.scss");
var snap_ui_1 = require("@teamsnap/snap-ui");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var MultiSelectPicker_1 = __importDefault(require("../MultiSelectPicker/MultiSelectPicker"));
var Role;
(function (Role) {
  Role["OrgAdmin"] = "organization_admin";
  Role["ProgramAdmin"] = "program_admin";
  Role["ProgramCoordinator"] = "program_coordinator";
  Role["Owner"] = "owner";
  Role["Admin"] = "admin";
  Role["DivisionCoordinator"] = "division_coordinator";
})(Role = exports.Role || (exports.Role = {}));
exports.defaultRole = {
  role: '',
  roleError: false,
  season: '',
  seasonError: false,
  programs: [],
  programsError: false,
  divisions: [],
  divisionsError: false
};
var convertDivisions = function convertDivisions(data) {
  return data.showSeason.divisions.map(function (x) {
    return {
      value: "".concat(x.id),
      label: x.name
    };
  }).slice().sort(function (a, b) {
    return a.label.localeCompare(b.label);
  });
};
var RolesAndPermissions = React.forwardRef(function (_a, ref) {
  var programs = _a.programs,
    seasons = _a.seasons,
    roles = _a.roles,
    setRoles = _a.setRoles,
    isLoadingDivisions = _a.isLoadingDivisions,
    queryDivisions = _a.queryDivisions;
  var _b = React.useState({}),
    seasonDivisions = _b[0],
    setSeasonDivisions = _b[1];
  var loadDivisions = React.useCallback(function () {
    var seasonIds = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      seasonIds[_i] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
      var state, _a, seasonIds_1, seasonId, data;
      var _b, _c;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            state = __assign({}, seasonDivisions);
            _a = 0, seasonIds_1 = seasonIds;
            _d.label = 1;
          case 1:
            if (!(_a < seasonIds_1.length)) return [3 /*break*/, 4];
            seasonId = seasonIds_1[_a];
            if (!(seasonId && !seasonDivisions[seasonId])) return [3 /*break*/, 3];
            setSeasonDivisions(__assign(__assign({}, seasonDivisions), (_b = {}, _b[seasonId] = 'loading', _b)));
            return [4 /*yield*/, queryDivisions({
              variables: {
                seasonId: +seasonId
              }
            })];
          case 2:
            data = _d.sent().data;
            state = __assign(__assign({}, state), (_c = {}, _c[seasonId] = convertDivisions(data), _c));
            _d.label = 3;
          case 3:
            _a++;
            return [3 /*break*/, 1];
          case 4:
            setSeasonDivisions(state);
            return [2 /*return*/];
        }
      });
    });
  }, [seasonDivisions, setSeasonDivisions, queryDivisions]);
  React.useImperativeHandle(ref, function () {
    return {
      loadDivisions: loadDivisions
    };
  }, [loadDivisions]);
  var setRole = function setRole(index, key) {
    return function (value) {
      var hasError = typeof value === 'string' ? !value : !value.length;
      setRoles(roles.map(function (x, i) {
        var _a;
        return i !== index ? x : __assign(__assign({}, x), (_a = {}, _a[key] = value, _a["".concat(key, "Error")] = hasError, _a));
      }));
    };
  };
  return React.createElement(React.Fragment, null, roles.map(function (data, index) {
    return React.createElement("div", {
      key: index,
      className: "u-flex u-flexCol ".concat(index ? 'roles-divider' : '')
    }, React.createElement(teamsnap_ui_1.FieldGroup, {
      mods: "u-spaceTopMd",
      status: data.roleError ? 'error' : undefined
    }, React.createElement(teamsnap_ui_1.FieldLabel, {
      name: "roles[".concat(index, "].role")
    }, "Role", React.createElement("span", {
      className: "sui-text-red-40"
    }, "*")), React.createElement(teamsnap_ui_1.Select, {
      name: "roles[".concat(index, "].role"),
      className: "SelectBox SelectBox--large",
      inputProps: {
        value: data.role,
        onChange: function onChange(e) {
          return setRole(index, 'role')(e.target.value);
        }
      },
      options: [{
        label: '',
        value: ''
      }, {
        label: 'Organization Admin',
        value: Role.OrgAdmin
      }, {
        label: 'Program Admin',
        value: Role.ProgramAdmin
      }, {
        label: 'Program Coordinator',
        value: Role.ProgramCoordinator
      }, {
        label: 'Division Coordinator',
        value: Role.DivisionCoordinator
      }]
    }), React.createElement(teamsnap_ui_1.FieldMessage, {
      status: data.roleError ? 'error' : undefined
    }, "\n            ".concat(data.roleError ? 'Role is required' : '', "\n            ").concat(data.role === Role.OrgAdmin ? 'Access to all areas of the org' : '', "\n            ").concat(data.role === Role.ProgramAdmin ? 'Access to all seasonal areas of assigned programs' : '', "\n            ").concat(data.role === Role.DivisionCoordinator ? 'Access to all areas of assigned divisions, except financial information on financials, invoicing, and registration pages.' : '', "\n            ").concat(data.role === Role.ProgramCoordinator ? 'Access to most seasonal areas of assigned program, except financial information on financials, invoicing, and registration pages.' : '', "\n          "))), React.createElement(teamsnap_ui_1.FieldGroup, {
      mods: "".concat([Role.ProgramAdmin, Role.ProgramCoordinator].includes(data.role) ? 'u-spaceTopMd' : 'u-hidden'),
      status: data.programsError ? 'error' : undefined
    }, React.createElement(teamsnap_ui_1.FieldLabel, {
      name: "roles[".concat(index, "].programs")
    }, "Programs", React.createElement("span", {
      className: "sui-text-red-40"
    }, "*")), React.createElement(MultiSelectPicker_1.default, {
      options: programs.slice().sort(function (a, b) {
        return a.label.localeCompare(b.label);
      }),
      selected: data.programs,
      updateSelectedOptions: setRole(index, 'programs')
    }), React.createElement(teamsnap_ui_1.FieldMessage, {
      status: data.programsError ? 'error' : undefined
    }, data.programsError ? 'Select at least one program' : '')), data.role === Role.DivisionCoordinator && React.createElement(React.Fragment, null, React.createElement(teamsnap_ui_1.FieldGroup, {
      mods: "u-spaceTopMd",
      status: data.seasonError ? 'error' : undefined
    }, React.createElement(teamsnap_ui_1.FieldLabel, {
      name: "roles[".concat(index, "].season")
    }, "Season", React.createElement("span", {
      className: "sui-text-red-40"
    }, "*")), React.createElement(teamsnap_ui_1.Select, {
      disabled: isLoadingDivisions,
      name: "roles[".concat(index, "].season"),
      className: "SelectBox SelectBox--large",
      inputProps: {
        value: data.season,
        onChange: function onChange(e) {
          setRole(index, 'season')(e.target.value);
          loadDivisions(e.target.value);
        }
      },
      options: __spreadArray([{
        label: '',
        value: ''
      }], seasons.slice().sort(function (a, b) {
        return a.label.localeCompare(b.label);
      }), true)
    }), React.createElement(teamsnap_ui_1.FieldMessage, {
      status: data.seasonError ? 'error' : undefined
    }, data.seasonError ? 'Season is required' : '')), React.createElement(teamsnap_ui_1.FieldGroup, {
      mods: "u-spaceTopMd",
      status: data.divisionsError ? 'error' : undefined
    }, React.createElement(teamsnap_ui_1.FieldLabel, {
      name: "roles[".concat(index, "].divisions")
    }, "Divisions", React.createElement("span", {
      className: "sui-text-red-40"
    }, "*")), seasonDivisions[data.season] === 'loading' && React.createElement(teamsnap_ui_1.Loader, {
      type: "spin",
      text: "Loading..."
    }), !seasonDivisions[data.season] && React.createElement(MultiSelectPicker_1.default, {
      disabled: true,
      options: [],
      selected: [],
      updateSelectedOptions: function updateSelectedOptions() {}
    }), Array.isArray(seasonDivisions[data.season]) && data.divisions && React.createElement(MultiSelectPicker_1.default, {
      options: seasonDivisions[data.season],
      selected: data.divisions,
      updateSelectedOptions: setRole(index, 'divisions')
    }), React.createElement(teamsnap_ui_1.FieldMessage, {
      status: data.divisionsError ? 'error' : undefined
    }, data.divisionsError ? 'Select at least one division' : ''))), roles.length > 1 && React.createElement(teamsnap_ui_1.Button, {
      type: "link",
      testId: "remove-role",
      mods: "sui-text-red-40 delete-button",
      onClick: function onClick() {
        return setRoles(roles.filter(function (_, i) {
          return i !== index;
        }));
      }
    }, React.createElement(snap_ui_1.Icon, {
      size: "s",
      name: "delete"
    }), "Remove"));
  }), React.createElement(teamsnap_ui_1.Button, {
    type: "link",
    testId: "add-role",
    mods: roles.length === 1 ? 'u-spaceTopMd' : '',
    onClick: function onClick() {
      return setRoles(__spreadArray(__spreadArray([], roles, true), [exports.defaultRole], false));
    }
  }, "+ Add another role"));
});
exports.default = RolesAndPermissions;